import React from "react";
import IconUserManagement from "./IconFiles/UserIcons/IconUserManagement";
import AngleBracketIcon from "./IconFiles/CommonIcons/AngleBracketIcon";
import DashboardIcon from "./IconFiles/CommonIcons/DashboardIcon";
import AddUserIcon from "./IconFiles/UserIcons/AddUserIcon";
import ViewProfileIcon from "./IconFiles/UserIcons/ViewProfileIcon";
import UpdatePasswordIcon from "./IconFiles/UserIcons/UpdatePasswordIcon";
import NewLeadIcon from "./IconFiles/MenuIcons/NewLeadIcon";
import LeadsIcon from "./IconFiles/LeadsIcons/LeadsIcon";
import ClientsIcon from "./IconFiles/MenuIcons/ClientsIcon";
import JobsIcon from "./IconFiles/MenuIcons/JobsIcon";
import SettingIcons from "./IconFiles/MenuIcons/SettingIcons";
import LogOutIcons from "./IconFiles/MenuIcons/LogOutIcons";
import ProfilePictureIcon from "./IconFiles/MenuIcons/ProfilePictureIcon";
import DropdownIcon from "./IconFiles/MenuIcons/DropdownIcon";
import HotLeadsIcon from "./IconFiles/LeadsIcons/HotLeadsIcon";
import WarmLeadsIcon from "./IconFiles/LeadsIcons/WarmLeadIcon";
import ApproveLeadsIcon from "./IconFiles/LeadsIcons/ApproveLeadsIcon";
import InterestedLeadsIcon from "./IconFiles/LeadsIcons/InterestedLeadsIcon";
import DrawerIcon from "./IconFiles/CommonIcons/DrawerIcon";
import CameraIcon from "./IconFiles/CommonIcons/CameraIcon";
import LoginAuthImg from "./IconFiles/CommonIcons/LoginAuthIMG";
import SignUpAuthImg from "./IconFiles/CommonIcons/SignUpAuthIMG";
import EditIcon from "./IconFiles/CommonIcons/EditIcon";
import WelcomeIMG from "./IconFiles/UserIcons/WelcomeIMG";
import Facebook from "./IconFiles/CommonIcons/SocialMediaSVGS/Facebook";
import LinkedIn from "./IconFiles/CommonIcons/SocialMediaSVGS/LinkedIn";
import TikTok from "./IconFiles/CommonIcons/SocialMediaSVGS/TikTok";
import Instagram from "./IconFiles/CommonIcons/SocialMediaSVGS/Instagram";
import Twitter from "./IconFiles/CommonIcons/SocialMediaSVGS/Twitter";
import AppleIcon from "./IconFiles/CommonIcons/SocialMediaSVGS/AppleIcon";
import WikipediaIcon from "./IconFiles/CommonIcons/SocialMediaSVGS/WikipediaIcon";
import PinterestIcon from "./IconFiles/CommonIcons/SocialMediaSVGS/PinterestIcon";
import YoutubeIcon from "./IconFiles/CommonIcons/SocialMediaSVGS/YoutubeIcon";
import AmazonIcon from "./IconFiles/CommonIcons/SocialMediaSVGS/AmazonIcon";
import AddJob from "./IconFiles/BreadcrumIcons/Addjob";
import AllLeadsIcon from "./IconFiles/LeadsIcons/AllLeadsIcon";
import ViewIcon from "./IconFiles/CommonIcons/ViewIcon";
import DeleteIcon from "./IconFiles/CommonIcons/DeleteIcon";
import RightIcon from "./IconFiles/CommonIcons/rightIcon";
import DownloadIcon from "./IconFiles/CommonIcons/downloadIcon";
import OperatorsIcon from "./IconFiles/MenuIcons/OperatorsIcon";
import InterestLevelIcon from "./IconFiles/CommonIcons/erniee-says/interest-level";
import DecisionMakingIcon from "./IconFiles/CommonIcons/erniee-says/decision-making";
import UrgencyIcon from "./IconFiles/CommonIcons/erniee-says/urgency";
import ClientEngagementIcon from "./IconFiles/CommonIcons/erniee-says/client-engagement";
import ErnieeSuggestionIcon from "./IconFiles/CommonIcons/erniee-says/erniee-suggestion";
import LogoWithoutText from "./IconFiles/CommonIcons/logoWithoutText";
import WorkSpaceIcon from "./IconFiles/MenuIcons/WorkSpaceIcon";
import AiIcon from "./IconFiles/MenuIcons/AiIcon";
import RejectLeadsIcon from "./IconFiles/LeadsIcons/RejectLeadsIcon";
import InProgressLeadsIcon from "./IconFiles/LeadsIcons/InProgressLeadsIcon";
import SystemErrorIcon from "./IconFiles/LeadsIcons/SystemErrorIcon";
import CalendarIcon from "./IconFiles/CommonIcons/CalendarIcon";
import SummaryIcon from "./IconFiles/CommonIcons/SummaryIcon";
import AudioWaveIcon from "./IconFiles/CommonIcons/AudioWave";
import ChatIcon from "./IconFiles/CommonIcons/ChatIcon";
import LeadHistoryIcon from "./IconFiles/LeadsIcons/LeadHistory";
import LocationIcon from "./IconFiles/LeadsIcons/LocationIcon";
import HighIntentRateIcon from "./IconFiles/CommonIcons/HighIntentRateIcon";
import LowIntentPercentageIcon from "./IconFiles/CommonIcons/LowIntentPercentageIcon";
import EmailIcon from "./IconFiles/CommonIcons/EmailIcon";
import DeliveredIcon from "./IconFiles/CommonIcons/DeliveredIcon";
import ViewHistoryIcon from "./IconFiles/CommonIcons/ViewHistoryIcon";
import LikeIcon from "./IconFiles/CommonIcons/LikeIcon";
import DislikeIcon from "./IconFiles/CommonIcons/DislikeIcon";
import InfoIcon from "./IconFiles/CommonIcons/InfoIcon";
import SingleAiIcon from "./IconFiles/CommonIcons/SingleAiIcon";
import CompanyIcon from "./IconFiles/CommonIcons/CompanyIcon";

interface Props {
  breadcrumb: string;
  activeColor?: string;
  bgColor?: string;
}

const ICON_MAP: Record<string, React.ElementType> = {
  dashboard: DashboardIcon,
  userManagement: IconUserManagement,
  angleBracket: AngleBracketIcon,
  addUser: AddUserIcon,
  viewProfile: ViewProfileIcon,
  updatePassword: UpdatePasswordIcon,
  newLead: NewLeadIcon,
  leads: LeadsIcon,
  customers: ClientsIcon,
  jobs: JobsIcon,
  addJob: AddJob,
  settings: SettingIcons,
  logout: LogOutIcons,
  profilePicture: ProfilePictureIcon,
  dropdown: DropdownIcon,
  allLeads: AllLeadsIcon,
  hotLeads: HotLeadsIcon,
  warmLeads: WarmLeadsIcon,
  interestedLeads: InterestedLeadsIcon,
  approveLeads: ApproveLeadsIcon,
  drawer: DrawerIcon,
  camera: CameraIcon,
  loginIMG: LoginAuthImg,
  signupIMG: SignUpAuthImg,
  edit: EditIcon,
  welcomeIMG: WelcomeIMG,
  facebook: Facebook,
  linkedin: LinkedIn,
  tiktok: TikTok,
  instagram: Instagram,
  twitter: Twitter,
  apple: AppleIcon,
  wikipedia: WikipediaIcon,
  pinterest: PinterestIcon,
  youtube: YoutubeIcon,
  amazon: AmazonIcon,
  view: ViewIcon,
  delete: DeleteIcon,
  right: RightIcon,
  download: DownloadIcon,
  operators: OperatorsIcon,
  interestLevel: InterestLevelIcon,
  decisionMaking: DecisionMakingIcon,
  urgency: UrgencyIcon,
  clientEngagement: ClientEngagementIcon,
  ErnieeSuggestion: ErnieeSuggestionIcon,
  logoWithoutText: LogoWithoutText,
  workSpace: WorkSpaceIcon,
  aiIcon: AiIcon,
  rejectedLeads: RejectLeadsIcon,
  inProgressLeads: InProgressLeadsIcon,
  systemError: SystemErrorIcon,
  calendarIcon: CalendarIcon,
  summaryIcon: SummaryIcon,
  audioWaveIcon: AudioWaveIcon,
  chatIcon: ChatIcon,
  leadHistoryIcon: LeadHistoryIcon,
  locationIcon: LocationIcon,
  highIntentRateIcon: HighIntentRateIcon,
  lowIntentPercentageIcon: LowIntentPercentageIcon,
  emailIcon: EmailIcon,
  deliveredIcon: DeliveredIcon,
  viewHistoryIcon: ViewHistoryIcon,
  likeIcon: LikeIcon,
  dislikeIcon: DislikeIcon,
  infoIcon:InfoIcon,
  singleAiIcon: SingleAiIcon,
  companyIcon: CompanyIcon,
};

// Define which icons should use white color instead of activeColor
const COLOR_MAP: Set<string> = new Set(["profilePicture"]);

const IconHome: React.FC<Props> = ({
  breadcrumb,
  activeColor = "#0f1560",
  bgColor,
}) => {
  const IconComponent = ICON_MAP[breadcrumb] || ViewProfileIcon;
  const iconColor = COLOR_MAP.has(breadcrumb) ? "white" : activeColor;

  return <IconComponent activeColor={iconColor} bgColor={bgColor} />;
};

export default IconHome;
